import { Component, OnChanges, SimpleChanges, Output, EventEmitter, Input } from '@angular/core';
import { OnDestroyMixin } from '@w11k/ngx-componentdestroyed';

import { Dictionary } from 'app/shared/models';
import { CustomAddressFieldValue } from '../../custom-form.types';

@Component({
  selector: 'app-custom-add-properties',
  templateUrl: './custom-add-properties.component.html',
  styleUrls: ['./custom-add-properties.component.scss'],
})
export class CustomAddPropertiesComponent extends OnDestroyMixin implements OnChanges {
  @Input() setValues: Dictionary<any>;
  @Input() readonly: boolean;

  @Output() onValueChanged = new EventEmitter<{ properties: Partial<CustomAddressFieldValue>[] }>();

  propertiesTracker: number[] = [0];
  properties: any[] = [{ address: { city: '', state: '', postal_code: '', street: '' } }];

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.setValues?.currentValue) {
      const newValues = changes.setValues.currentValue;
      if (newValues?.cff_add_properties?.properties && Array.isArray(newValues.cff_add_properties.properties)) {
        this.properties = [...newValues.cff_add_properties.properties];
        this.propertiesTracker = newValues.cff_add_properties.properties.map((_: any, i: number) => i);
        this.onValueChanged.emit({ properties: this.properties });
      }
    }
  }

  onPropertyAddressFieldUpdate(event: { property: { address: any } }, index: number = null): void {
    this.properties[index] = event.property;

    this.onValueChanged.emit({ properties: this.properties });
  }

  noop(): void {}

  addProp(): void {
    this.propertiesTracker = [...this.propertiesTracker, this.propertiesTracker.length];
    this.properties = [
      ...this.properties,
      { property: { address: { city: '', state: '', postal_code: '', street: '' } } },
    ];
  }

  delProp(index: number): void {
    this.propertiesTracker = this.propertiesTracker.filter((_, i) => i !== index);
    this.properties = this.properties.filter((_, i) => i !== index);
    this.onValueChanged.emit({ properties: this.properties });
  }
}
